export const dismissReason = {
    ProsecutionPerempt: 1,
    DefensePerempt: 2,
    ForCause: 3,
    ForHardship: 4,
    BothPerempt: 5
};